import React from 'react';

const BreatheCalm = () => {
    return ( 
        <div>
            <p>Last updated: December 9th, 2020</p>
            <p>
                <strong>bmacpherson.com</strong> (“we” or “us” or “our”) respects the privacy of our users (“user” or “you”). This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our mobile application (the “Application”). Please read this Privacy Policy carefully. IF YOU DO NOT AGREE WITH THE TERMS OF THIS PRIVACY POLICY, PLEASE DO NOT ACCESS THE APPLICATION.
            </p>
            
            <p>
                We reserve the right to make changes to this Privacy Policy at any time and for any reason. We will alert you about any changes by updating the “Last updated” date of this Privacy Policy. You are encouraged to periodically review this Privacy Policy to stay informed of updates. You will be deemed to have been made aware of, will be subject to, and will be deemed to have accepted the changes in any revised Privacy Policy by your continued use of the Application after the date such revised Privacy Policy is posted.
            </p>
            
            
            <h2>COLLECTION OF YOUR INFORMATION</h2>
            
            <p>
                We do not collect any information on our users in this app.
            </p>
        
            <p>
                We may request access or permission to certain features from your mobile device, including your mobile device’s vibration functionality. If you wish to change our access or permissions, you may do so in your device’s settings.
            </p>
            
            <h2>
                CONTACT US
            </h2>
            
            <p>
                If you have questions or comments about this Privacy Policy, <br/>please contact us at:
            </p>
            <p>
                Bmacpherson.com
                <br/>5B, 137 Wong Nai Chung Road
                <br/>Happy Valley, Hong Kong
                
                <br/><br/>
                <a href='tel:+852-6708-1340'>+852-6708-1340</a>
                <br/>
                <a 
                    href='mailto:brimac1634@gmail.com' 
                    target='_blank' 
                    rel='noopener noreferrer'
                >
                    Brimac1634@gmail.com
                </a>
            </p>
        </div>
     );
}
 
export default BreatheCalm;